import React from 'react';
import PropTypes from 'prop-types';
import { useParams, Link, Redirect } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Main from 'components/templates/Main';
import Errors from 'components/shared/Errors';
import Success from 'components/shared/Success';
import PATHS from 'constants/paths';
import { isCommissionHost as isCommissionHostSelector } from 'selectors/user';
import useHostFiles from '../hooks/useHostFiles';
import { getCottageName } from '../utils';
import CottageFilesList from '../components/CottageFilesList';

const CottageFilesContainer = () => {
  const isCommissionHost = useSelector(isCommissionHostSelector);
  const { cottageId } = useParams();
  const id = parseInt(cottageId, 10);

  if (!isCommissionHost || !Number.isFinite(id) || id <= 0) {
    return <Redirect to={PATHS.cottages.root} />;
  }

  return <CottageFilesContainerContent id={id} />;
};

const CottageFilesContainerContent = ({ id }) => {
  const hf = useHostFiles();

  const cottage = React.useMemo(() => hf.cottages.find((c) => c.id === id), [hf.cottages, id]);

  const cottageFiles = hf.groupedFiles[id] || [];
  const cottageName = getCottageName(cottage);

  return (
    <Main
      title={
        <Button color="inherit" component={Link} to={PATHS.cottages.root}>
          <ArrowBack /> &nbsp; <FormattedMessage id="cottages.files" defaultMessage="Files" />
        </Button>
      }
    >
      <CottageFilesList
        config={hf.config}
        files={cottageFiles}
        cottage={cottage}
        cottageId={id}
        cottageName={cottageName}
        allCottages={hf.cottages}
        counts={hf.counts}
        isLoading={hf.isLoading}
        isUploading={hf.isUploading}
        uploadProgress={hf.uploadProgress}
        uploadFileIndex={hf.uploadFileIndex}
        uploadFileCount={hf.uploadFileCount}
        isUpdating={hf.isUpdating}
        onUpload={hf.onUpload}
        onView={hf.onView}
        onDownload={hf.onDownload}
        onRename={hf.onRename}
        onReassign={hf.onReassign}
        onDelete={hf.onDelete}
      />
      <Success success={hf.success} onClose={hf.onClearStatus} autoHideDuration={5000} />
      <Errors errors={hf.error} onClose={hf.onClearStatus} autoHideMs={5000} />
    </Main>
  );
};

CottageFilesContainerContent.propTypes = {
  id: PropTypes.number.isRequired,
};

export default CottageFilesContainer;
